import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import dayjs from 'dayjs';
import { useLocation, useNavigate } from 'react-router-dom';
import { getToken, storeAdmin } from '../../../services/LocalStorageService';
import { useActivityQuery } from '../../../services/dvagent';
import { Toaster } from '../attributes';

export default function Profile(user) {
  const location = useLocation();
  const navigate = useNavigate();
  const [log, setLog] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const itemsToShow = showAll ? log.length : 5;
  const { data:activityData, isSuccess:activityIsSuccess, error:activityError } = useActivityQuery({"email":user.user.email, "token":getToken(), "location":location});
  const [toasterData, setToasterData] = useState({
    trigger: false,
    status: true,
    symbol: '✔',
    message: '',
  });

  useEffect(() => {
    if (activityError) {
      if (activityError.status === 401) {
        // showToast(false, 'ⓘ', 'Unauthorized User');
        storeAdmin("false");
        navigate('/');
      } else {
        showToast(false, 'ⓘ', 'Unable to add user, server error');
      }
    }
    if (activityData && activityIsSuccess) {
      setLog(activityData.log)
    }
  }, [activityData, activityIsSuccess, activityError]);  

  const showToast = (status, symbol, message) => {
    setToasterData({
      trigger: true,
      status,
      symbol,
      message,
    });

    setTimeout(() => {
      setToasterData((prev) => ({
        ...prev,
        trigger: false,
      }));
    }, 5000); 
  };
  return (
    <>
      {toasterData.trigger && (
        <Toaster
          trigger={toasterData.trigger}
          status={toasterData.status}
          symbol={toasterData.symbol}
          message={toasterData.message}
        />
      )}

      <Grid 
        item 
        xs={12} 
        sx={{ display: "flex", alignItems: "center", gap: 2, marginY:2 }}
      >
        <Avatar
          src="../user/default-user.gif"
          sx={{ width: 80, height: 80, borderColor: '#A8A196', borderRadius: 3 }}
          variant="square"
        />
        <div>
          <Typography 
            gutterBottom 
            component="div" 
            sx={{ fontSize: 16, fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1 }}
          >
            {user.user.first_name} {user.user.last_name}
            {user.user.is_superuser && (
              <img 
                width={30} 
                src="../assets/app/verified.png" 
                alt="verified" 
              />
            )}
          </Typography>
          <Typography 
            gutterBottom 
            variant="body2" 
            color="text.secondary" 
            sx={{ fontSize: 15 }}
          >
            {user.user.email}
          </Typography>
        </div>
      </Grid> 

      {user.access.length > 0 &&(
        <Grid item xs={12}>
          <Typography variant="h6" color="text.secondary">
            Permission
          </Typography>
        </Grid>
      )}

      {user.access.map((item) =>
      <Grid item xs={12} sm={6} md={4} xl={3}>
        <Card sx={{ display: 'flex', borderLeft: 5, borderLeftColor: '#A8A196' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', height:170 }}>
            <CardContent sx={{ flex: '1 0 auto' }}>
              <Typography variant="h6" gutterBottom>
                {item.name}
              </Typography>
              <Typography color="text.secondary" component="div">
                Network&nbsp;:&nbsp;{item.network_name}
              </Typography>
              <Typography color="text.secondary" component="div">
                Permission&nbsp;:&nbsp;<span style={{ fontWeight: 'bold', color:'#96C291' }} >{item.permission}</span>
              </Typography>
              <Typography color="text.secondary" component="div">
                Date&nbsp;Assigned&nbsp;:&nbsp; {dayjs(item.created_on).format('YYYY-MM-DD HH:mm:ss')}  
              </Typography>
            </CardContent>
          </Box>
        </Card>
      </Grid>
      )}

      <Grid item xs={12}>
        {log.length > 0 &&(
          <Typography variant="h6" mt={3} color="text.secondary">
            Activity
          </Typography>
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row-reverse',
          }}
        >
          {log.length > 5 && (
            <Button 
              variant="text"
              onClick={() => setShowAll(!showAll)}>
              {showAll ? 'Less' : 'More'}
            </Button>
          )}
        </Box>
      </Grid>
      
      {log.slice(0, itemsToShow).map((item) => (
        <Grid item xs={12} key={item.id}>
          <Card sx={{ marginBottom: 1, borderLeft: 5, borderLeftColor: '#A8A196' }}>
            <Typography variant="" component="div" sx={{ fontSize: '90%', padding: 2, verticalAlign: 'middle' }}>
              <Grid container alignItems="center">
                <Grid item xs={12} sm={4} md={2} xl={2} sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                  {dayjs(item.created_on).format('YYYY-MM-DD HH:mm:ss')}
                </Grid>
                <Grid item xs={12} sm={8} md={10} xl={10}>
                  <span>{item.action}</span>
                </Grid>
              </Grid>
            </Typography>
          </Card>
        </Grid>
      ))}
    </>
  );
}

